import apiClient from './apiClient';

const leaderboardService = {
  getMyGroupRanking: async () => {
    try {
      const response = await apiClient.get('/GroupLeaderboard/my-ranking');
      return response.data;
    } catch (error) {
      console.error('Error fetching group ranking:', error);
      throw error;
    }
  }
};

export default leaderboardService;
